import { useCallback } from 'react'

import { Menu } from '@mantine/core'

import { useLocation } from '@redwoodjs/router'
import { useMutation } from '@redwoodjs/web'

import { useAuth } from 'src/auth'
import { ProfileMenuButton } from 'src/components/Navigation/ProfileMenuButton/ProfileMenuButton'
import StyledMenu from 'src/components/Overlays/StyledMenu/StyledMenu'
import { BEFORE_LOGOUT } from 'src/graphql/users.graphql'
import IconDashboard from 'src/icons/IconDashboard'
import IconLogout from 'src/icons/IconLogout'
import IconShield from 'src/icons/IconShield'
import { adminHomePath, isAdminSurface } from 'src/lib/adminSurface'
import { isAdmin } from 'src/lib/auth/permissions'

export const ProfileMenu = () => {
  const { logOut, currentUser } = useAuth()
  const { pathname } = useLocation()

  const showAdminLinks = isAdmin(currentUser)
  const onAdminSurface = isAdminSurface(pathname)

  const [beforeLogout] = useMutation(BEFORE_LOGOUT, {
    onCompleted: async () => {
      await logOut({
        logoutParams: {
          returnTo: window.location.origin,
        },
      })
    },
  })

  const handleLogout = useCallback(async () => {
    await beforeLogout()
  }, [beforeLogout])

  return (
    <StyledMenu>
      <Menu.Target>
        <ProfileMenuButton />
      </Menu.Target>
      <Menu.Dropdown>
        {showAdminLinks && onAdminSurface && (
          <Menu.Item component="a" href="/">
            <div className="flex flex-row items-center gap-2 hover:stroke-doubleNickel-brand-500">
              <IconDashboard className="h-4 w-4 fill-none stroke-doubleNickel-gray-700" />
              Dashboard
            </div>
          </Menu.Item>
        )}
        {showAdminLinks && !onAdminSurface && (
          <Menu.Item component="a" href={adminHomePath()}>
            <div className="flex flex-row items-center gap-2 hover:stroke-doubleNickel-brand-500">
              <IconShield className="h-4 w-4 fill-none stroke-doubleNickel-gray-700" />
              Admin
            </div>
          </Menu.Item>
        )}
        <Menu.Item onClick={handleLogout}>
          <div className="flex flex-row items-center gap-2 hover:stroke-doubleNickel-brand-500  ">
            <IconLogout className="h-4 w-4 fill-none" />
            Logout
          </div>
        </Menu.Item>
      </Menu.Dropdown>
    </StyledMenu>
  )
}
